/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, markType } from "./type";
import { BrushUtil } from "./BrushUtil";
import { DeviceUtils } from "./DeviceUtils";
/**
 * @hidden
 */
var FontDefaults = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FontDefaults, _super);
    function FontDefaults() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FontDefaults.a7 = function (a) {
        return "Titillium Web, " + a + ", Arial, sans-serif";
    };
    FontDefaults.$t = markType(FontDefaults, 'FontDefaults');
    FontDefaults.legendLabelsBrush = BrushUtil.h(255, 37, 37, 37);
    FontDefaults.legendLabelsFontSizeConst = 13;
    FontDefaults.legendLabelsFontSize = DeviceUtils.f(13);
    FontDefaults.legendLabelsFontConst = "Verdana";
    FontDefaults.legendLabelsFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.dataLegendFontBrush = BrushUtil.h(255, 37, 37, 37);
    FontDefaults.dataLegendFontSizeConst = 13;
    FontDefaults.dataLegendFontSize = DeviceUtils.f(13);
    FontDefaults.dataLegendFontFamilyConst = "Verdana";
    FontDefaults.dataLegendFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.dataLegendFontWeight = "400";
    FontDefaults.dataLegendFontStyle = "Normal";
    FontDefaults.dataLegendFontStretch = "Normal";
    FontDefaults.dataLegendFontVariant = "Normal";
    FontDefaults.dataLegendHeaderFontWeight = "600";
    FontDefaults.chartAxisLabelBrush = BrushUtil.h(255, 78, 78, 78);
    FontDefaults.chartFontSizeConst = 13;
    FontDefaults.chartFontSize = DeviceUtils.f(13);
    FontDefaults.chartFontNameConst = "Verdana";
    FontDefaults.chartXAxisLabelsMarginTop = 5;
    FontDefaults.chartXAxisLabelsMarginBottom = 5;
    FontDefaults.chartXAxisLabelsMarginLeft = 2;
    FontDefaults.chartXAxisLabelsMarginRight = 2;
    FontDefaults.chartYAxisLabelsMarginTop = 2;
    FontDefaults.chartYAxisLabelsMarginBottom = 2;
    FontDefaults.chartYAxisLabelsMarginLeft = 5;
    FontDefaults.chartYAxisLabelsMarginRight = 5;
    FontDefaults.chartFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.chartFontWeight = "400";
    FontDefaults.chartFontStyle = "Normal";
    FontDefaults.chartFontStretch = "Normal";
    FontDefaults.chartFontVariant = "Normal";
    FontDefaults.chartTitleFontSizeConst = 20;
    FontDefaults.chartTitleFontSize = DeviceUtils.f(20);
    FontDefaults.chartTitleNameConst = "Verdana";
    FontDefaults.chartTitleFontWeight = "600";
    FontDefaults.chartSubtitleFontSizeConst = 20;
    FontDefaults.chartSubtitleFontSize = DeviceUtils.f(20);
    FontDefaults.chartSubtitleNameConst = "Verdana";
    FontDefaults.chartSubtitleFontWeight = "600";
    FontDefaults.tooltipLabelsBrush = BrushUtil.h(255, 78, 78, 78);
    FontDefaults.tooltipLabelsFontSizeConst = 13;
    FontDefaults.tooltipLabelsFontSize = DeviceUtils.f(FontDefaults.tooltipLabelsFontSizeConst);
    FontDefaults.tooltipFontNameConst = "Verdana";
    FontDefaults.tooltipLabelsFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.gaugesFontBrush = BrushUtil.h(255, 97, 97, 97);
    FontDefaults.gaugesFontSizeConst = 12;
    FontDefaults.gaugesFontSize = DeviceUtils.f(12);
    FontDefaults.gaugesFontFamilyConst = "Verdana";
    FontDefaults.gaugesFontWeight = "600";
    FontDefaults.gaugesFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.gaugesFontStyle = "Normal";
    FontDefaults.gaugesFontStretch = "Normal";
    FontDefaults.gaugesFontVariant = "Normal";
    FontDefaults.gaugesTitleSizeConst = 12 * 2;
    FontDefaults.gaugesTitleSize = DeviceUtils.f(24);
    FontDefaults.gaugesSubtleSizeConst = 12 * 2;
    FontDefaults.gaugesSubtitleSize = DeviceUtils.f(24);
    FontDefaults.gaugesHighlightLabelSizeConst = 12 * 2;
    FontDefaults.gaugesHighlightLabelSize = DeviceUtils.f(24);
    FontDefaults.treemapFontSizeConst = 13;
    FontDefaults.treemapFontSize = DeviceUtils.f(13);
    FontDefaults.treemapHeaderFontSizeConst = 13;
    FontDefaults.treemapHeaderFontSize = DeviceUtils.f(13);
    FontDefaults.treemapFontFamilyConst = "Verdana";
    FontDefaults.treemapFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.treemapHeaderFontFamily = FontDefaults.a7("Verdana");
    FontDefaults.zoomSliderFontSizeConst = 10;
    FontDefaults.zoomSliderFontSize = DeviceUtils.f(10);
    FontDefaults.zoomSliderNameConst = "Verdana";
    return FontDefaults;
}(Base));
export { FontDefaults };
